export default __webpack_public_path__ + "static/media/logo1.828d62f5.png";